<template>
  <div>
      <div :style="{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left'
        }">

            <div v-if="!$store.getters.getUserGroupAlerts.hide_inventory_cost_price" style="margin-top: 10px;">
                <span class="label">
                    Cost Price                    
                </span> 
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    type="number"
                    v-model="$store.state.inventoryMaster.props.cost_price"
                    style="width: 400px;">
                </el-input>
            </div>
             <div v-if="!$store.getters.getUserGroupAlerts.hide_inventory_cost_price" style="margin-top: 10px;">
                <span class="label">
                    Profit (%)                   
                </span> 
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    type="number"
                    @blur="addProfitPercent"
                    v-model="$store.state.inventoryMaster.props.profit_percent"
                    style="width: 400px;">
                </el-input>
            </div>
            
            <div style="margin-top: 10px;" 
                v-if="$store.state.inventoryMaster.props.item_type === 1 
                    && $store.getters.getFabricPriceSlabList.length > 0">
                <span type="label">Fabric Price Category</span>
                <br>
                <el-select 
                    size="small"
                    v-model="$store.state.inventoryMaster.props.fabric_price_category_id" 
                    filterable 
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getFabricPriceSlabList"
                        :key="index"
                        :label="data.price_category_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.price_category_name"></span>
                    </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;" v-else>
                <span type="label">Sales Price</span>
                <br>
                <el-input 
                    @blur="caluclateRate('sale_price')"
                    @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.sale_price"
                    type="number"
                    size="small"
                    style="width: 400px;">
                </el-input>
                <br v-if="$store.state.inventoryMaster.props.item_type === 1"><br v-if="$store.state.inventoryMaster.props.item_type === 1">
                <el-checkbox v-if="$store.state.inventoryMaster.props.item_type === 1" v-model="$store.state.inventoryMaster.props.stitching_rate_flat">
                    Sales Price Flat For Stitching
                </el-checkbox>
                
                <div v-if="$store.state.inventoryMaster.props.stitching_rate_flat && $store.state.inventoryMaster.props.fabric_can_be_sold_as_retail">
                    <br>
                    <span type="label">Default Retail Fabric Units</span>
                    <br>
                    <el-input 
                        @blur="caluclateRate('default_retail_fabric_unit')"
                        @focus="$event.target.select()"
                        v-model="$store.state.inventoryMaster.props.default_retail_fabric_unit"
                        type="number"
                        size="small"
                        style="width: 400px;">
                    </el-input>
                </div>
                <div v-if="$store.state.inventoryMaster.props.stitching_rate_flat">
                    <br>
                    <span type="label">Sales Price/Unit</span>
                    <br>
                    <el-input 
                        @blur="caluclateRate('flat_price')"
                        @focus="$event.target.select()"
                        v-model="$store.state.inventoryMaster.props.flat_price"
                        type="number"
                        size="small"
                        style="width: 400px;">
                    </el-input>
                </div>
                <br><br>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Discount (%) On Sale</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.discount_percent"
                    type="number"
                    size="small"
                    style="width: 400px;">
                </el-input>                
            </div>
            
            <div style="margin-top: 50px;" v-if="$store.getters.isIndiaTax">
                <h1>GST Settings</h1>
                <br>
                <span class="label">HSN/SAC Code</span><br>
                <el-input @focus="$event.target.select()"
                    id="hsnCode"
                    size="small"
                    v-model.trim="$store.state.inventoryMaster.props.hsn_sac_code"
                    style="width: 400px;"></el-input>            
            </div>
            <div style="margin-top: 20px;" v-if="$store.getters.isIndiaTax">
                <span class="label">GST (%)</span><br>
                <el-input @focus="$event.target.select()"
                    id="tailoringTaxPercent"
                    size="small"
                    type="number"
                    v-model="$store.state.inventoryMaster.props.tax_percent"
                    style="width: 400px;"></el-input>   
            </div>
      </div>
  </div>
</template>

<script>
export default {
    methods: {
        caluclateRate(source) {

            let flat_price = parseFloat(this.$store.state.inventoryMaster.props.flat_price)
            let default_retail_fabric_unit = parseFloat(this.$store.state.inventoryMaster.props.default_retail_fabric_unit)
            let sale_price = parseFloat(this.$store.state.inventoryMaster.props.sale_price)

            if(source == "sale_price") {
                this.$store.state.inventoryMaster.props.flat_price = (sale_price/default_retail_fabric_unit).toFixed(2)
            } else if(source == "flat_price") {
                this.$store.state.inventoryMaster.props.sale_price = (flat_price*default_retail_fabric_unit).toFixed(2)
            } else if(source == "default_retail_fabric_unit") {
                this.$store.state.inventoryMaster.props.flat_price = (sale_price/default_retail_fabric_unit).toFixed(2)
            }

        },
        addProfitPercent() {
            let costPrice = parseFloat(this.$store.state.inventoryMaster.props.cost_price)
            let profitPercent = parseFloat(this.$store.state.inventoryMaster.props.profit_percent)
            
            if(profitPercent>0 && costPrice>0) {
                this.$store.state.inventoryMaster.props.sale_price = (costPrice+(costPrice*(profitPercent/100)))
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/PriceAndTax.vue